<template>
  <div class="row mb-2">
    <div class="col-6">
      <h5>Basisinformationen</h5>
    </div>
  </div>

  <div v-if="unemployed">
    <div class="row mb-1 align-items-center">

      <div class="col-12 col-md-6 mb-3 mb-md-0">
        <h6 v-if="unemployed.status === 'new'" class="m-0">
          <span style="padding-right: 10px;">Status: </span>
          <div class="status-pill orange p-2 mr-2"
               :data-title="unemployed.statusTranslated"
               data-toggle="tooltip" title="">
          </div>
          {{ unemployed.statusTranslated }}
        </h6>

        <h6 v-if="unemployed.status === 'active'" class="m-0">
          <span style="padding-right: 10px;">Status: </span>
          <div class="status-pill green p-2 mr-1"
               :data-title="unemployed.statusTranslated"
               data-toggle="tooltip" title="">
          </div>
          {{ unemployed.statusTranslated }}
        </h6>

        <h6 v-if="unemployed.status === 'finished'" class="m-0">
          <span style="padding-right: 10px;">Status: </span>
          <div class="status-pill red p-2 mr-1"
               :data-title="unemployed.statusTranslated"
               data-toggle="tooltip" title="">
          </div>
          {{ unemployed.statusTranslated }}
        </h6>
      </div>

      <div class="col-12 col-md-6">
        <div class="d-flex flex-column flex-md-row justify-content-md-end gap-2">

          <a v-if="!hasDocuments"
             class="btn btn-soft-green font-weight-bold px-3 d-flex mr-md-2 align-items-center justify-content-center shadow-sm w-100 w-md-auto"
             @click="router.push({ name: 'unemployedPrivateCoachingDocuments', params: { id: unemployed.id } })">
            <i class="fa-solid fa-file-invoice mr-2"></i> Digitale Dokumente
          </a>

          <a v-if="hasDocuments"
             class="btn btn-soft-green font-weight-bold px-3 d-flex md-0 mr-md-2 align-items-center justify-content-center shadow-sm w-100 w-md-auto"
             @click="router.push({ name: 'unemployedPrivateCoachingList', params: { id: unemployed.id } })">
            <i class="fa-solid fa-list-check mr-2"></i> Maßnahmen
          </a>

          <a class="btn btn-primary font-weight-bold px-4 d-flex mr-md-2 mt-2 mt-md-0 align-items-center justify-content-center shadow-sm w-100 w-md-auto"
             @click="router.push({ name: 'unemployedEditForm', params: { id: unemployed.id } })">
            <i class="fa-solid fa-pen-to-square mr-2"></i> Bearbeiten
          </a>

          <a class="btn btn-outline-danger font-weight-bold px-3 d-flex mt-2 mt-md-0 align-items-center justify-content-center w-100 w-md-auto"
             @click="showDeleteModal(unemployed.id)">
            <i class="fa-solid fa-trash-can mr-2"></i> Löschen
          </a>

        </div>
      </div>

    </div>


    <div class="row m-0 border rounded shadow-sm overflow-hidden mt-3"
         style="font-size: 14px; background-color: hsla(40,5%,89%,.2)!important;">

      <div class="col-12 col-md-6 col-lg-4 p-4 border-right-md bg-light-soft">
        <div class="border-bottom pb-2 mb-3">
          <span class="font-weight-bold text-dark text-uppercase small" style="letter-spacing: 0.5px;">
            <i class="fa fa-id-card text-primary mr-2"></i>Systemdaten
          </span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Kundennummer</small>
          <span class="text-dark font-weight-bold">{{ unemployed.customerNumber || '-' }}</span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Standort</small>
          <span class="text-dark font-weight-bold" v-if="unemployed.location">{{ unemployed.location.name }}</span>
          <span class="text-muted" v-else>-</span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">JC / AA Nummer</small>
          <span class="text-dark font-weight-bold">{{ unemployed.aaNumber || '-' }}</span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Versicherungsnummer</small>
          <span class="text-dark font-weight-bold">{{ unemployed.insuranceNumber || '-' }}</span>
        </div>

        <div class="info-block mb-0 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Erstellt am</small>
          <span class="text-secondary"><i class="fa fa-calendar-alt mr-1 text-primary" style="font-size: 12px;"></i> {{ unemployed.createdAt }}</span>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-4 p-4 border-right-lg">
        <div class="border-bottom pb-2 mb-3">
          <span class="font-weight-bold text-dark text-uppercase small" style="letter-spacing: 0.5px;">
            <i class="fa fa-user text-primary mr-2"></i>Persönliche Daten
          </span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Vorname</small>
          <span class="text-dark font-weight-bold">{{ unemployed.firstName }}</span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Nachname</small>
          <span class="text-dark font-weight-bold">{{ unemployed.lastName }}</span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Telefonnummer</small>
          <span class="text-dark"><i class="fa fa-phone mr-1 text-primary" style="font-size: 12px;"></i> {{ unemployed.phone || '-' }}</span>
        </div>

        <div class="info-block mb-0 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">E-Mail-Adresse</small>
          <span class="text-dark">
        <i class="fa fa-envelope mr-1 text-primary" style="font-size: 12px;"></i>
        <a :href="'mailto:' + unemployed.email" class="text-decoration-none text-primary font-weight-bold">{{ unemployed.email }}</a>
         </span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm mt-2">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Geburtsdatum</small>
          <span class="text-dark"><i class="fa fa-birthday-cake mr-1 text-danger" style="font-size: 12px;"></i> {{ unemployed.birthdate || '-' }}</span>
        </div>
      </div>

      <div class="col-12 col-md-6 col-lg-4 p-4 bg-light-soft-right">
        <div class="border-bottom pb-2 mb-3">
          <span class="font-weight-bold text-dark text-uppercase small" style="letter-spacing: 0.5px;">
            <i class="fa fa-map-marker-alt text-primary mr-2"></i>Adresse
          </span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">Straße</small>
          <span class="text-dark font-weight-bold">{{ unemployed.address || '-' }}</span>
        </div>

        <div class="info-block mb-2 py-1 px-2 rounded-sm">
          <small class="text-muted d-block text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.5px;">PLZ / Ort</small>
          <span class="text-dark font-weight-bold">{{ unemployed.zip }} {{ unemployed.city }}</span>
        </div>
      </div>

    </div>
  </div>

  <ModalDelete
      v-model="showModal"
      :header="t('general.delete_item_header')"
      :onDelete="deleteClient">
  </ModalDelete>
</template>

<script setup>
import {defineProps, ref, toRef} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';

import ModalDelete from '@/components/modal/ModalDelete.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import unemployedService from "@/api/Unemployed"

const router = useRouter();
const {t} = useI18n();
const showModal = ref(false);
const isLoaded = ref(false);

const route = useRoute();
const name = route.name;
const hasDocuments =
    String(name ?? '')
        .toLowerCase()
        .includes('documents');

const props = defineProps({
  unemployed: {
    type: Object,
    require: true,
  },
});

const unemployed = toRef(props, 'unemployed');


function showDeleteModal(id) {
  CloseToast();
  showModal.value = true;
}

async function deleteClient() {
  try {
    await unemployedService.deleteUnemployed(unemployed.value.id);
    await router.push({name: 'unemployedNewAndActiveList'});

    SuccessToast(t('general.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    showModal.value = false;
  }
}

</script>

<style scoped>
.status-pill {
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

@media (min-width: 768px) {
  .border-right-md { border-right: 1px solid #e9ecef; }
}
@media (min-width: 992px) {
  .border-right-lg { border-right: 1px solid #e9ecef; }
}

.info-block {
  transition: background-color 0.2s ease;
}
.info-block:hover {
  background-color: #f8f9fa;
}

.bg-light-soft {
  background-color: #fcfdfe;
}

@media (min-width: 768px) {
  .border-right-md { border-right: 1px solid #eef1f5; }
}
@media (min-width: 992px) {
  .border-right-lg { border-right: 1px solid #eef1f5; }
  .bg-light-soft-right { background-color: #fcfdfe; }
}

.btn i {
  font-size: 1.1rem;
  vertical-align: middle;
}

.btn-soft-green {
  color: #146c43;
  background-color: #e2f7e9;
  border: 1px solid #c1eed2;
  transition: all 0.15s ease-in-out;
}

.btn-soft-green:hover {
  color: #ffffff;
  background-color: #146c43;
  border-color: #146c43;
}

.btn i {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 767.98px) {
  .element-wrapper .btn + .btn,
  .element-wrapper .all-wrapper .fc-button + .btn,
  .all-wrapper .element-wrapper .fc-button + .btn,
  .element-wrapper .all-wrapper .btn + .fc-button,
  .all-wrapper .element-wrapper .btn + .fc-button,
  .element-wrapper .all-wrapper .fc-button + .fc-button,
  .all-wrapper .element-wrapper .fc-button + .fc-button {
    margin-left: 0 !important;
    min-width: 100% !important;
  }
}

@media (min-width: 768px) {
  .element-wrapper .btn + .btn {
    margin-left: 0 !important;
  }
}

</style>
